import React from "react";

const WarrantyPolicyBanner = () => {
  return (
    <div className=" flex justify-center items-center text-white z-50 contact-banner">
      <h1 className=" text-white text-[32px] lg:text-[40px] mt-16 font-semibold leading-[97px]">
      Warranty Policy
    </h1>
  </div>
  
  );
};

export default WarrantyPolicyBanner;
